// import Home from '@material-ui/icons/Home';
// import SearchIcon from '@material-ui/icons/Search';
// import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
// import AddIcon from '@material-ui/icons/Add';
// import ImageIcon from '@material-ui/icons/Image';
// import FeaturedVideoIcon from '@material-ui/icons/FeaturedVideo';
import ChairSideHome from './tabContent/Home';
import Specialization from './tabContent/Specialization';
import NewRelease from './tabContent/NewRelease';
import MyList from './tabContent/MyList';
import ShowVideo from './tabContent/ShowVideo';
import Search from './tabContent/Search';
import PlayList from './tabContent/Playlist';
// import SearchIcon from '../../img/Chairside-Left-Search.svg'
import {ReactComponent as SearchIcon} from '../../img/Chairside-Left-Search.svg';
import {ReactComponent as HomeIcon} from '../../img/Chairside-Left-Home.svg';
import {ReactComponent as VideoLibraryIcon} from '../../img/Chairside-Left-New-Release.svg';
import {ReactComponent as AddIcon} from '../../img/Chairside-Left-Add-to-list.svg';
import {ReactComponent as ImageIcon} from '../../img/Chairside-Left-Screenshots.svg';
import {ReactComponent as FeaturedVideoIcon} from '../../img/Chairside-Left-Specialisation.svg';
import {ReactComponent as SavedVideo} from '../../img/savedVideo.svg';

import {ReactComponent as PlayListIcon} from '../../img/Chairside-playList.svg';
export const tabList = [
  {
    name : 'Search',
    icon : <SearchIcon/>
  },
  {
    name : 'Home',
    icon :  <HomeIcon  />
  },
  {
    name : 'New Releases',
    icon :  <VideoLibraryIcon  />
  },
  {
    name : 'Saved Videos',
    icon :  <SavedVideo />
  },
  {
    name : 'Chairside Screenshots',
    icon : <ImageIcon />
  },
  {
    name : 'Playlists',
    icon :<PlayListIcon/>
  },
  {
    name : 'Specializations',
    icon : <FeaturedVideoIcon style={{fontSize:'30px'}} />
  },
]

export const tabItems = [
  {
    name : 'Search',
    component : <Search />
  },
  {
    name : 'Home',
    component : <ChairSideHome/>
  },
  {
    name : 'New Releases',
    component :<NewRelease />
  },
  {
    name : 'Saved Videos',
    component :<MyList/>
  },
  {
    name : 'Screenshots',
    component :<ShowVideo />
  },
  {
    name : 'Playlists',
    component :<PlayList/>
  },
  {
    name : 'Specializations',
    component :<Specialization/>
  },

  
  
]

export const chairSideEducationVideos = [ 


    { "description" : "The Smoking Tire meets up with Chris and Jorge from CarsForAGrand.com to see just how far $1,000 can go when looking for a car.The Smoking Tire meets up with Chris and Jorge from CarsForAGrand.com to see just how far $1,000 can go when looking for a car.",
    "sources" :  "https://iandevlin.github.io/mdn/video-player-with-captions/video/sintel-short.mp4" ,
    "subtitle" : "https://iandevlin.github.io/mdn/video-player-with-captions/subtitles/vtt/sintel-en.vtt",
    "thumb" : "images/WhatCarCanYouGetForAGrand.jpg",
    "title" : "What care can you get for a grand?"
    },
    { "description" : "Big Buck Bunny tells the story of a giant rabbit with a heart bigger than himself. When one sunny day three rodents rudely harass him, something snaps... and the rabbit ain't no bunny anymore! In the typical cartoon tradition he prepares the nasty rodents a comical revenge.\n\nLicensed under the Creative Commons Attribution license\nhttp://www.bigbuckbunny.org",
      "sources" :  "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4" ,
      "subtitle" : "By Blender Foundation",
      "thumb" : "images/BigBuckBunny.jpg",
      "title" : "Big Buck Bunny"
    },
    { "description" : "The first Blender Open Movie from 2006",
      "sources" :  "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4" ,
      "subtitle" : "By Blender Foundation",
      "thumb" : "images/ElephantsDream.jpg",
      "title" : "Elephant Dream"
    },
    { "description" : "HBO GO now works with Chromecast -- the easiest way to enjoy online video on your TV. For when you want to settle into your Iron Throne to watch the latest episodes. For $35.\nLearn how to use Chromecast with HBO GO and more at google.com/chromecast.",
      "sources" :  "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4" ,
      "subtitle" : "By Google",
      "thumb" : "images/ForBiggerBlazes.jpg",
      "title" : "For Bigger Blazes"
    },
    { "description" : "Introducing Chromecast. The easiest way to enjoy online video and music on your TV—for when Batman's escapes aren't quite big enough. For $35. Learn how to use Chromecast with Google Play Movies and more at google.com/chromecast.",
      "sources" :  "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4" ,
      "subtitle" : "By Google",
      "thumb" : "images/ForBiggerEscapes.jpg",
      "title" : "For Bigger Escape"
    },
    { "description" : "Introducing Chromecast. The easiest way to enjoy online video and music on your TV. For $35.  Find out more at google.com/chromecast.",
      "sources" :  "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4" ,
      "subtitle" : "By Google",
      "thumb" : "images/ForBiggerFun.jpg",
      "title" : "For Bigger Fun"
    },
    { "description" : "Introducing Chromecast. The easiest way to enjoy online video and music on your TV—for the times that call for bigger joyrides. For $35. Learn how to use Chromecast with YouTube and more at google.com/chromecast.",
      "sources" :  "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4" ,
      "subtitle" : "By Google",
      "thumb" : "images/ForBiggerJoyrides.jpg",
      "title" : "For Bigger Joyrides"
    },
    { "description" :"Introducing Chromecast. The easiest way to enjoy online video and music on your TV—for when you want to make Buster's big meltdowns even bigger. For $35. Learn how to use Chromecast with Netflix and more at google.com/chromecast.", 
      "sources" :  "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4" ,
      "subtitle" : "By Google",
      "thumb" : "images/ForBiggerMeltdowns.jpg",
      "title" : "For Bigger Meltdowns"
    },
    { "description" : "Sintel is an independently produced short film, initiated by the Blender Foundation as a means to further improve and validate the free/open source 3D creation suite Blender. With initial funding provided by 1000s of donations via the internet community, it has again proven to be a viable development model for both open 3D technology as for independent animation film.\nThis 15 minute film has been realized in the studio of the Amsterdam Blender Institute, by an international team of artists and developers. In addition to that, several crucial technical and creative targets have been realized online, by developers and artists and teams all over the world.\nwww.sintel.org",
      "sources" :  "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4" ,
      "subtitle" : "By Blender Foundation",
      "thumb" : "images/Sintel.jpg",
      "title" : "Sintel"
    },
    { "description" : "Smoking Tire takes the all-new Subaru Outback to the highest point we can find in hopes our customer-appreciation Balloon Launch will get some free T-shirts into the hands of our viewers.",
      "sources" :  "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/SubaruOutbackOnStreetAndDirt.mp4" ,
      "subtitle" : "By Garage419",
      "thumb" : "images/SubaruOutbackOnStreetAndDirt.jpg",
      "title" : "Subaru Outback On Street And Dirt"
    },
    { "description" : "Tears of Steel was realized with crowd-funding by users of the open source 3D creation tool Blender. Target was to improve and test a complete open and free pipeline for visual effects in film - and to make a compelling sci-fi film in Amsterdam, the Netherlands.  The film itself, and all raw material used for making it, have been released under the Creatieve Commons 3.0 Attribution license. Visit the tearsofsteel.org website to find out more about this, or to purchase the 4-DVD box with a lot of extras.  (CC) Blender Foundation - http://www.tearsofsteel.org", 
      "sources" :  "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4" ,
      "subtitle" : "By Blender Foundation",
      "thumb" : "images/TearsOfSteel.jpg",
      "title" : "Tears of Steel"
    },
    { "description" : "The Smoking Tire heads out to Adams Motorsports Park in Riverside, CA to test the most requested car of 2010, the Volkswagen GTI. Will it beat the Mazdaspeed3's standard-setting lap time? Watch and see...",
      "sources" : "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/VolkswagenGTIReview.mp4" ,
      "subtitle" : "By Garage419",
      "thumb" : "images/VolkswagenGTIReview.jpg",
      "title" : "Volkswagen GTI Review"
    },
    { "description" : "The Smoking Tire is going on the 2010 Bullrun Live Rally in a 2011 Shelby GT500, and posting a video from the road every single day! The only place to watch them is by subscribing to The Smoking Tire or watching at BlackMagicShine.com",
      "sources" :  "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WeAreGoingOnBullrun.mp4" ,
      "subtitle" : "By Garage419",
      "thumb" : "images/WeAreGoingOnBullrun.jpg",
      "title" : "We Are Going On Bullrun"
    },
    { "description" : "The Smoking Tire meets up with Chris and Jorge from CarsForAGrand.com to see just how far $1,000 can go when looking for a car.The Smoking Tire meets up with Chris and Jorge from CarsForAGrand.com to see just how far $1,000 can go when looking for a car.",
      "sources" :  "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WeAreGoingOnBullrun.mp4" ,
      "subtitle" : "By Garage419",
      "thumb" : "images/WhatCarCanYouGetForAGrand.jpg",
      "title" : "What care can you get for a grand?"
    }
]

export const colors = [
    {
        colorName:"black",
        color:["#212121", "#1a1a1a"],
        subscription:true
    },
    {
        colorName:"silver",
        color:["#4b4e56", "#56585c"],
        subscription:true
    },
     {
        colorName:"dark blue",
        color:["#2c3c50", "#435a74"],
        subscription:true
    },
    {
        colorName:"brown",
        color:["#463e32", "#575143"],
         subscription:true
    },
    {
        colorName:"light blue",
        color:["#25587c","#25587c"],
        subscription:true
    },
    {
        colorName:"cyan",
        color:["#3d6668","#416a6c"],
        subscription:true
    },
    {
        colorName:"red",
        color:["#a43333","#a94040"],
        subscription:true
    },
    {
        colorName:"light",
        color:["#dddddd","#8d8d8d"],
        subscription:true
    },
    {
        colorName:"dark",
        color:["#181818","#181818"],
        subscription:true
    },
    {
        colorName:"granite",
        color:["#787878","#adadad"],
        subscription:false
    },   
    {
        colorName:"sky",
        color:["#66759a","#8493c1"],
        subscription:false
    },
    {
        colorName:"oak",
        color:["#6e513f","#906f5b"],
        subscription:false
    }      
]